import React, { type JSX, type ReactNode } from 'react';

import Avatar from '@mui/material/Avatar';
import { alpha, useTheme } from '@mui/material/styles';

type SettingsFeatureIconBoxProps = {
  children: ReactNode;
  size?: 'small' | 'medium';
};

const SettingsFeatureIconBox = ({ children, size = 'medium' }: SettingsFeatureIconBoxProps): JSX.Element => {
  const theme = useTheme();
  const dimension = size === 'small' ? theme.spacing(4) : theme.spacing(5);
  const iconSize = size === 'small' ? theme.spacing(2.25) : theme.spacing(3);

  return (
    <Avatar
      variant='rounded'
      aria-hidden
      sx={{
        width: dimension,
        height: dimension,
        flexShrink: 0,
        bgcolor: alpha(theme.palette.primary.main, 0.08),
        color: theme.palette.primary.main,
        '& > svg': {
          width: iconSize,
          height: iconSize,
        },
      }}
    >
      {children}
    </Avatar>
  );
};

export default SettingsFeatureIconBox;
